import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Zap, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background grid-bg">
      <div className="w-full max-w-sm glass rounded-2xl border border-border p-8">
        <div className="flex items-center gap-2.5 mb-8">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Zap className="h-6 w-6" />
          </div>
          <span className="font-display text-2xl font-extrabold">LeadFlow</span>
        </div>
        {sent ? (
          <div className="text-center" data-testid="forgot-confirmation">
            <MailCheck className="h-10 w-10 text-emerald-400 mx-auto" />
            <h2 className="font-display text-xl font-bold mt-4">Check your email</h2>
            <p className="text-sm text-muted-foreground mt-2">
              If that email is registered, a reset link has been sent.
            </p>
            <Link to="/login" className="text-sm text-primary hover:underline mt-6 inline-block" data-testid="back-to-login-link">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold">Reset password</h2>
            <p className="text-sm text-muted-foreground mt-1">We'll email you a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
              </div>
              {error && <p className="text-sm text-rose-400">{error}</p>}
              <Button type="submit" className="w-full bg-primary text-primary-foreground hover:bg-primary/90" disabled={loading} data-testid="forgot-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <Link to="/login" className="text-sm text-primary hover:underline mt-6 inline-block">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
